// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","icon":"icon-3OluO","button":"button-2s2Bf","no":"no-x2Q-A","content":"content-39ClI"};